import React, { useState, useEffect } from "react";

const TrimmableTextComponent = ({ selectedEventLive }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const PromoterUrlLive = localStorage.getItem("name"); // Assuming AdminUsername is stored in localStorage as 'AdminUsername'

  // Construct the URL with the AdminUsername (promoterName) from localStorage
  const deeplinkUrl = `https://patt.club/deeplink.html?eventid=${selectedEventLive}&promoterName=${PromoterUrlLive}`;

  // Function to handle text click and copy the URL
  const handleTextClick = () => {
    navigator.clipboard
      .writeText(deeplinkUrl)
      .then(() => {
        alert("Link copied to clipboard!");
      })
      .catch(() => {
        alert("Failed to copy the link.");
      });
  };

  // Function to handle redirect on SVG click
  const handleRedirect = () => {
    window.open(deeplinkUrl, "_blank", "noopener,noreferrer");
  };

  // Conditionally set text and SVG size based on screen width
  const textSize = windowWidth <= 780 ? "10px" : "16px";
  const svgSize = windowWidth <= 780 ? 16 : 24; // SVG size adjusts similarly

  return (
    <div
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
        width: "90%",
        maxWidth: `${Math.min(windowWidth - 20, 1200)}px`,
        resize: "horizontal",
        cursor: "pointer" // Make the cursor a pointer to indicate clickability
      }}
    >
      {/* Clickable text that copies the URL */}
      <span
        style={{
          backgroundColor: "#f0f0f0",
          border: "1px solid #ced4da",
          borderRadius: "8px", // Add rounded corners for better visual appeal
          padding: "10px 15px", // Add padding for content spacing
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          wordBreak: "break-all",
          flex: 1, // Let the text take up available space
          color: "grey", // Grey color for the link
          fontSize: textSize // Adjust font size based on window width
        }}
        onClick={handleTextClick} // Copy text on click
      >
        {deeplinkUrl}
      </span>

      {/* SVG icon for redirecting to the deeplink URL */}
      <span
        style={{
          backgroundColor: "#f0f0f0",
          borderRadius: "8px",
          padding: "7.5px 10px", // Add padding for content spacing
          border: "1px solid #ced4da",
          marginLeft: "10px",
          flexShrink: 0 // Prevent the button from shrinking
        }}
        onClick={handleRedirect} // Redirect on click
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width={svgSize} // Adjust SVG width
          height={svgSize} // Adjust SVG height
        >
          <path
            fill="#383838"
            d="M14 3H21V10H19V5.41L11.41 13L10 11.59L17.59 4H14V3ZM5 5H11V7H5V19H17V13H19V19C19 20.1 18.1 21 17 21H5C3.9 21 3 20.1 3 19V7C3 5.9 3.9 5 5 5Z"
          ></path>
        </svg>
      </span>
    </div>
  );
};

export default TrimmableTextComponent;
